export default "__VITE_ASSET__Bg3U5MkW__"